import React, { Component } from 'react';
import { Grid, Typography, IconButton, Button } from '@material-ui/core';
import { SupplierProductMapping, ProductMappingStatus } from '../../api/models/SupplierProductMapping';
import { SupplierProductsSearchBoxCnn } from '../../ProductsSearch/connected/SupplierProductsSearchBoxCnn';
import { Close } from '@material-ui/icons';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';


type Props = {
    saveMapping: (spm: SupplierProductMapping) => void,
    close: () => void
}

type State = {
    newSpm: SupplierProductMapping,
    savedSuccesfully: boolean | null
}

class AddNewProduct extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            newSpm: {
                _isDirty: true,
                _isMapped: false,
                askingPrice: 0,
                minimalPriceModifier: 1,
                attributes: {},
                boxingNoOfItems: -1,
                boxingType: "",
                boxingWeight: -1,
                boxingWeightUnit: "",
                catalogueProductId: "",
                catalogueReference: null,
                currency: "",
                mappingStatus: ProductMappingStatus.NEW,
                supplierId: -1,
                supplierProductId: "",
                supplierProductName: "",
                unit: ""
            },
            savedSuccesfully: null
        }
    }

    render() {
        return (
            <div>
                {this.state.savedSuccesfully === null &&
                    <Grid container style={{minHeight: '75vh'}}>
                        <Grid item sm={12}>

                            <Grid container alignItems="center"><Grid item sm={10}><Typography variant="h2">Search for product to place your offer</Typography></Grid><Grid item sm={2} style={{ textAlign: 'right' }}><IconButton onClick={() => this.props.close()}><Close /></IconButton></Grid></Grid>
                            <br />
                            <SupplierProductsSearchBoxCnn
                                onSaveChange={this.props.saveMapping}
                                mappingObj={this.state.newSpm}
                                onMappingFinish={() => { this.setState({ savedSuccesfully: true }) }}
                                showPriceControls={true}
                                searchString="*"
                            />
                        </Grid>
                    </Grid>
                }

                {this.state.savedSuccesfully === true &&
                    <Grid container spacing={4} style={{ textAlign: "center" }}>
                        <Grid item xs={12} sm={12}>
                            <CheckCircleOutlineIcon style={{ color: 'green', fontSize: "7.5em" }} />
                            <Typography variant="h2">Success!</Typography>
                            <Typography variant="h4">New product was added to your offer.</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'right' }}>
                            <Button onClick={() => this.setState({ savedSuccesfully: null })} variant="contained" color="primary">Add more</Button>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'left' }}>
                            <Button onClick={this.props.close} variant="outlined" color="primary">Close</Button>
                        </Grid>
                    </Grid>
                }
            </div>
        );
    }
}

export default AddNewProduct;